<template>
  <div class="qmyx-container my-customer-detail">
    <div class="header-box">
      <img
        class="icon"
        src="https://assets.rurushishi.com/yq-rs-make/huafa/img/name.png"
      />
      <div class="name">{{ name }}</div>
      <div class="phone">{{ phone }}</div>
    </div>
    <div
      :class="item.time ? 'detail-item-checked' : 'detail-item'"
      v-for="(item, index) in dataList"
      :key="index"
    >
      <div class="point "></div>
      <div
        :class="isShowOrangeLine(index)"
        v-if="index < dataList.length - 1"
      ></div>
      <div class="desc">{{ item.name }}</div>
      <div class="time">{{ item.time }}</div>
    </div>
  </div>
</template>
<script>
import { getCustomerDetail } from "./api";
export default {
  name: "My-Customer-Detail",
  data() {
    return {
      name: "",
      phone: "",
      dataList: [
        { name: "推荐成功", nodeId: "10" },
        { name: "到访", nodeId: "20" },
        { name: "诚意登记", nodeId: "30" },
        { name: "认购", nodeId: "40" },
        { name: "签约", nodeId: "50" },
        { name: "提佣", nodeId: "60" },
        { name: "佣金发放", nodeId: "70" }
      ],
      dataCheckList: {
        10: [],
        20: [],
        30: [],
        40: [],
        50: [],
        60: [],
        70: []
      },
      lastActiveNode: 0
    };
  },
  activated() {
    this.removeData();
    this.loadData();
  },
  methods: {
    async loadData() {
      const id = this.$route.params.id;
      const res = await getCustomerDetail(id);
      if (res.custom) {
        this.name = res.custom.cusName;
        this.phone = res.custom.cusTel;
      }
      if (res.follows) {
        const { data } = res.follows;
        for (let index = 0; index < data.length; index++) {
          // if (index < data.length) {
          this.dataList.forEach((item, i) => {
            if (item.nodeId === data[index].nodeId) {
              // const dataItem = this.dataList[index];
              this.dataCheckList[item.nodeId].push({
                ...data[index],
                time: data[index].nodeDate
              });
              // item.time = data[index].nodeDate;
              if (item.nodeId / 10 >= this.lastActiveNode) {
                this.lastActiveNode = item.nodeId / 10;
              }
            }
          });
          // }
        }
        for (let key in this.dataCheckList) {
          if (this.dataCheckList[key].length === 1) {
            this.dataList[key / 10 - 1].time = this.dataCheckList[key][0].time;
          } else if (this.dataCheckList[key].length > 1) {
            let checkFlag = false;
            let temp = "";
            this.dataCheckList[key].forEach(i => {
              if (temp === "") {
                temp = i;
              }
              if (temp.contractNum == i.contractNum) {
                checkFlag = true;
              } else {
                checkFlag = false;
              }
            });
            if (checkFlag) {
              this.dataCheckList[key].sort((a, b) => {
                const timestampA = new Date(a.nodeDateS).getTime();
                const timestampB = new Date(b.nodeDateS).getTime();
                return timestampB - timestampA;
              });
            } else {
              this.dataCheckList[key].sort((a, b) => {
                const timestampA = new Date(a.nodeDateS).getTime();
                const timestampB = new Date(b.nodeDateS).getTime();
                return timestampA - timestampB;
              });
            }
            this.dataList[key / 10 - 1].time = this.dataCheckList[key][0].time;
          }
        }
      }
    },
    isShowOrangeLine(index) {
      const nextIndex = index + 1;
      if (nextIndex < this.lastActiveNode) {
        // return this.dataList[nextIndex].time
        //   ? "point-line-orange"
        //   : "point-line";
        return "point-line-orange";
      } else {
        return "point-line";
      }
    },
    removeData() {
      this.name = "";
      this.phone = "";
      this.dataList = [
        { name: "推荐成功", nodeId: "10" },
        { name: "到访", nodeId: "20" },
        { name: "诚意登记", nodeId: "30" },
        { name: "认购", nodeId: "40" },
        { name: "签约", nodeId: "50" },
        { name: "提佣", nodeId: "60" },
        { name: "佣金发放", nodeId: "70" }
      ];
      this.dataCheckList = {
        10: [],
        20: [],
        30: [],
        40: [],
        50: [],
        60: [],
        70: []
      };
      this.lastActiveNode = 0;
    }
  }
};
</script>
<style scoped lang="scss">
.my-customer-detail {
  .header-box {
    height: 0.9rem;
    margin-top: 0.04rem;
    margin-right: 0.48rem;
    margin-left: 0.48rem;
    display: flex;
    justify-self: start;
    align-items: center;
    box-shadow: 0 0.02rem 0 0 #efefef;
    border-radius: 0.02rem;
    margin-bottom: 0.48rem;
    .icon {
      width: 0.4rem;
      height: 0.4rem;
    }
    .name {
      font-size: 0.32rem;
      color: #f07b24;
      letter-spacing: 0;
      margin-left: 0.16rem;
    }
    .phone {
      font-size: 0.32rem;
      color: #f07b24;
      letter-spacing: 0;
      margin-left: 0.4rem;
    }
  }
  .color-orange {
    color: #f07b24;
  }
  .detail-item {
    position: relative;
    .point {
      width: 0.2rem;
      height: 0.2rem;
      background: #ffffff;
      border: 0.04rem solid #dddddd;
      border-radius: 50%;
      margin-left: 0.48rem;
    }

    .desc {
      position: absolute;
      left: 1rem;
      top: -0.04rem;
      font-size: 0.3rem;
      color: #999999;
      letter-spacing: 0;
    }
    .time {
      position: absolute;
      font-size: 0.28rem;
      color: #bbbbbb;
      letter-spacing: 0;
      left: 1rem;
      top: 0.38rem;
    }
  }
  .point-line {
    width: 0.04rem;
    height: 0.78rem;
    margin-left: 0.6rem;
    background: #dddddd;
  }
  .point-line-orange {
    width: 0.04rem;
    height: 1.22rem;
    margin-left: 0.6rem;
    background: #f07b24;
  }
  .detail-item-checked {
    position: relative;
    .point {
      width: 0.2rem;
      height: 0.2rem;
      background: #f07b24;
      border: 0.04rem solid #f07b24;
      border-radius: 50%;
      margin-left: 0.48rem;
    }

    .desc {
      position: absolute;
      left: 1rem;
      top: -0.04rem;
      font-size: 0.3rem;
      color: #f07b24;
      letter-spacing: 0;
    }
    .time {
      position: absolute;
      font-size: 0.28rem;
      color: #bbbbbb;
      letter-spacing: 0;
      left: 1rem;
      top: 0.34rem;
    }
  }
}
</style>
